import { useNavigate } from 'react-router-dom';
import { ContentUploader } from '../../components/ContentUploader';
import { ArrowLeft } from 'lucide-react';

export function ContentUploadPage() {
  const navigate = useNavigate();

  const handleUploadComplete = (courseId: string) => {
    // Navigate to the course editor after successful upload
    navigate(`/author/courses/${courseId}/edit`);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <button
                onClick={() => navigate('/author')}
                className="p-2 hover:bg-gray-100 rounded-lg mr-4"
              >
                <ArrowLeft className="w-5 h-5" />
              </button>
              <h1 className="text-xl font-semibold">Upload Course Content</h1>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="py-12">
        <ContentUploader
          onUploadComplete={handleUploadComplete}
          authorId={localStorage.getItem('userId') || 'default-author'}
        />
      </div>
    </div>
  );
}